<loader></loader>
<router-outlet></router-outlet>